import { FC, ReactElement, ReactNode, } from 'react';
import classnames from 'classnames';
import { ILayOutPageContentInfo, LayOutPageContentProps, LayOutPageContentHeaderProps, LayOutPageItemEnum } from '../interface';

const LayOutPageContent: FC<LayOutPageContentProps> = props => {
  const { children, className, ...restProps } = props;
  const classes = classnames('yb-layout-page-content', className);
  const renderChildren = (childrenNodes: ReactNode): ReactElement => {
    const contentInfo: ILayOutPageContentInfo = {
      header: [],
      content: [],
    };
    if (Array.isArray(childrenNodes) && childrenNodes.length) {
      childrenNodes.forEach(item => {
        const childElement = item as React.FunctionComponentElement<LayOutPageContentHeaderProps>;
        if (!childElement.type) return null;
        const { displayName } = childElement.type;
        switch (displayName) {
          case LayOutPageItemEnum.Header:
            contentInfo.header.push(item);
            break;
          default:
            contentInfo.content.push(item);
        }
      });
    } else {
      if (childrenNodes) return renderChildren([childrenNodes]);
    }
    return (
      <>
        <div className={classes} {...restProps}>
          {contentInfo.header}
          {contentInfo.content}
        </div>
      </>
    );
  };
  return renderChildren(children);
};

LayOutPageContent.displayName = LayOutPageItemEnum.Content;

export default LayOutPageContent;
